module.exports = __webpack_public_path__ + "img/tablecell-color.75cf36e.svg";